<template>
  <nav class="navbar">
    <PromoBanner />
    <DesktopMenu :site-map="siteMap" />
    <MobileMenu :site-map="siteMap" />
  </nav>
</template>

<script>
import DesktopMenu from '@/components/navigation/DesktopMenu.vue'
import MobileMenu from '@/components/navigation/MobileMenu.vue'
import PromoBanner from '@/components/sections/PromoBanner.vue'

export default {
  name: 'Navbar',
  components: {
    DesktopMenu,
    MobileMenu,
    PromoBanner,
  },
  computed: {
    reserveLabel() {
      return this.current_lang_upper === 'fr' ? 'Réserver' : 'Book'
    },
    siteMap() {
      return this.$store.getters.getSiteMap.links
    },
  },
  methods: {
    change_lang() {
      const nav = document.getElementById('navbarTogglerMain')
      const navBTN = document.getElementById('navBTN')
      nav.classList.remove('show')
      navBTN.classList.add('collapsed')
    },
  },
}
</script>
